export const icon = [
  'иконка',
  'иконки',
  'иконок',
]

export const download = [
  'скачивание',
  'скачивания',
  'скачиваний',
]

export const generations = [
  'генерация',
  'генерации',
  'генераций',
]

export const neirogenerations = [
  'нейрогенерация',
  'нейрогенерации',
  'нейрогенераций',
]

export const months = [
  'месяц',
  'месяца',
  'месяцев',
]

export const pluralize = (count: number, list: string[]): string => {
  let word: string
  const i = count % 100
  if (i >= 11 && i <= 19) {
    word = list[2]
  } else {
    const j = count % 10
    if (j === 1) {
      word = list[0]
    } else if (j >= 2 && j <= 4) {
      word = list[1]
    } else {
      word = list[2]
    }
  }
  return count + ' ' + word
}
